import { render, staticRenderFns } from "./FAQTable.vue?vue&type=template&id=54213ba6&"
import script from "./FAQTable.vue?vue&type=script&lang=js&"
export * from "./FAQTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports